import { SHIPPING_MODEL, user } from 'core';

export function useBusinessUnit() {
  const {
    data: { shippingModel },
  } = user.hooks.useUser();

  const shippingModelReseller = shippingModel?.availables?.find(
    (model) =>
      model.code === SHIPPING_MODEL.RESELLER ||
      model.code === SHIPPING_MODEL.ORDER_EXPRESS ||
      model.code === SHIPPING_MODEL.RETROACTIVE_RESELLER ||
      model.code === SHIPPING_MODEL.PICKUP_STORE ||
      model.code === SHIPPING_MODEL.KEY_ACCOUNT ||
      model.code === SHIPPING_MODEL.KEY_ACCOUNT_ORDER_EXPRESS ||
      model.code === SHIPPING_MODEL.KEY_ACCOUNT_RETROACTIVE,
  );

  const shippingModelPickupStore = shippingModel?.availables?.find(
    (model) =>
      model.code === SHIPPING_MODEL.KEY_ACCOUNT_PICKUP_STORE ||
      model.code === SHIPPING_MODEL.PICKUP_STORE,
  );

  return {
    shippingModelReseller,
    shippingModelPickupStore,
    distributionCenterDefaultCode:
      shippingModel?.default?.delivery.distributionCenterCode || undefined,
  };
}
